import { Props } from '@/pages/checkout/Models/address';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
/**
 * Types
 */
export interface TypesType {
    SEND_PIN: string;
    VALIDATE_PIN: string;
    REQUEST_DEBTS: string;
    DEBTS_PULLING: string;
    CLEAR_USER: string;
    SEARCH_ADDRESS: string;
    PAYMENT_CARD: string;
    PAYMENT_PIX: string;
    AUTHORIZE: string;
    SEND_MESSAGE: string;
}

export const Types: TypesType = {
    SEND_PIN: 'user/sendPin',
    VALIDATE_PIN: 'user/validatePin',
    REQUEST_DEBTS: 'user/requestDebts',
    DEBTS_PULLING: 'user/debtsPulling',
    CLEAR_USER: 'user/clearUser',
    SEARCH_ADDRESS: 'user/searchAddress',
    PAYMENT_CARD: 'user/paymentCard',
    PAYMENT_PIX: 'user/paymentPix',
    AUTHORIZE: 'user/authorize',
    SEND_MESSAGE: 'user/sendMessage',
}
/**
 * Initial State
 */
interface InitialState {
    [key: string]: string | number | boolean | unknown;
    plate?: string;
    card?: {
        cardNumber?: string;
        cardName?: string;
        cardExpiration?: string;
        cardDocument?: string;
    };
    address?: {
        zipcode?: string;
        streetName?: string;
        number?: string;
        complement?: string;
        neighborhood?: string;
        city?: string;
        state?: string;
        stateCode?: string;
        isDisabled?: boolean;
    }
}

export type State = InitialState

export const initialState: InitialState = {
    isLoading: false,
}

export interface Callback {
    callback: (
        success: boolean,
        errorMessage?: string,
    ) => void;
    callbackLight: (
        success: boolean
    ) => void;
    callbackZipcode: (
        success: boolean,
        address?: Props['responseAddress'],
    ) => void;
}

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<InitialState>) {
            Object.keys(action.payload).forEach((item) => {
                state[item] = action.payload[item];
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendPin(_, __: PayloadAction<{
            document: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validatePin(_, __: PayloadAction<{
            document: string;
            pin: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestDebts(_, __: PayloadAction<{
            plate: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        debtsPulling(_, __: PayloadAction<{
            requestId: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clearUser(state: { [key: string]: unknown }) {
            Object.keys(state).forEach((item) => {
                const value = state[item];
                switch (typeof value) {
                    case "string":
                        state[item] = "";
                        break;
                    case "boolean":
                        state[item] = false;
                        break;
                    case "number":
                        state[item] = 0;
                        break;
                    default:
                        state[item] = null;
                }
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        searchAddress(_, __: PayloadAction<{
            zipcode: string;
            callback: Callback['callbackZipcode'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        paymentCard(_, __: PayloadAction<{
            plate: string;
            card: {
                number: string;
                name: string;
                expiration: string;
                document: string;
            };
            address: {
                zipcode: string;
                streetName: string;
                neighborhood: string;
                addressStreet: string;
                number: string;
                complement: string;
                city: string;
                state: string;
            };
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        paymentPix(_, __: PayloadAction<{
            document: string;
            name: string;
            email: string;
            phone: string;
            plate: string;
            address: {
                zipcode: string;
                streetName: string;
                neighborhood: string;
                addressStreet: string;
                number: string;
                complement: string;
                city: string;
                state: string;
            };
            callback: (success: boolean, code?: {
                plate: string;
                pixCode: string;
                codeExpiration: string;
                total: number;
                pixImage: string;
                pixImageType: string;
                pixImageWidth: number;
            }) => void;
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        authorize(_, __: PayloadAction<{
            plate: string;
            token: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendMessage(_, __: PayloadAction<{
            name: string;
            email: string;
            message: string;
            userId?: string;
            callback: Callback['callbackLight'];
        }>) {},
    }
});
export const { 
    setUser, 
    sendPin, 
    validatePin, 
    requestDebts, 
    debtsPulling,
    clearUser,
    searchAddress,
    paymentCard,
    paymentPix,
    authorize,
    sendMessage,
} = userSlice.actions;

export default function userReducer(
    state: InitialState = initialState,
    action: PayloadAction<unknown>
  ): InitialState {
    return userSlice.reducer(state, action);
  }
